import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-322f93d5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "電子書籍・電子雑誌（オンライン資料）自動収集申出 Webフォーム", -1))
const _hoisted_3 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_OnlineAgreement = _resolveComponent("OnlineAgreement")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_Breadcrumb, {
      list: _ctx.BreadcrumbList,
      pageNum: 1
    }, null, 8, ["list"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_OnlineAgreement)
    ])
  ]))
}